import { defineStore } from 'pinia';

export const useUpgradePopupStore = defineStore('upgradePopup', {
    state: () => ({
        isPopupOpen: false  // More specific state indicator
    }),
    actions: {
        openPopup() {
            this.isPopupOpen = true;  // Directly opens the popup
        },
        closePopup() {
            this.isPopupOpen = false; // Directly closes the popup
        }
    }
});
